/**
 * ADR-0166 — Benchmarks view wire types. Shared between the origin route
 * (`services/api/src/http/routes/v1/sites-benchmarks.ts`) and the dashboard
 * view (`apps/dashboard/src/views/benchmarks/**`). snake_case throughout.
 *
 * The wire carries `cohort_is_synthetic: true` in v1 (the cohort numbers
 * come from server-side canonical constants; only the merchant's own
 * `yours` values are read from live tenant-scoped tables). The two
 * enforcement invariants — opt-out gate, k-anonymity floor — are
 * server-side (see ADR-0166 §3 for the contract). k<10 → `cards` and
 * `category_breakdown` are `null`; k<30 → `category_breakdown` is `null`.
 *
 * The closed enum arrays `BENCHMARK_INDUSTRIES` / `BENCHMARK_VOLUME_BANDS`
 * are runtime iterables the dashboard's `<select>` renderers + the route's
 * closed-enum coercion both consume, so the industry / volume-band vocabulary
 * cannot drift between server and client.
 */
/**
 * Ordered runtime table for the industry `<select>` control. Labels are
 * ported byte-for-byte from `docs/reference/Foyer_Dashboard_CURRENT.jsx`
 * (lines 6634–6642) and are the same strings the founder-approved
 * prototype ships with.
 */
export const BENCHMARK_INDUSTRIES = [
    { id: 'food_bev', label: 'Food & beverage' },
    { id: 'apparel', label: 'Apparel & accessories' },
    { id: 'home_garden', label: 'Home & garden' },
    { id: 'electronics', label: 'Electronics' },
    { id: 'health_beauty', label: 'Health & beauty' },
    { id: 'services', label: 'Digital services' },
    { id: 'all', label: 'All industries' },
];
/**
 * Ordered runtime table for the volume-band `<select>` control. Labels
 * are ported byte-for-byte from `docs/reference/Foyer_Dashboard_CURRENT.jsx`
 * (lines 6646–6651).
 */
export const BENCHMARK_VOLUME_BANDS = [
    { id: 'small', label: '<1k calls/mo' },
    { id: 'mid', label: '1k-10k calls/mo' },
    { id: 'large', label: '10k-100k calls/mo' },
    { id: 'huge', label: '100k+ calls/mo' },
];
//# sourceMappingURL=benchmarks.js.map